const LayoutDemo = ({ children }) => {
  return <div>{children}</div>;
};

export default LayoutDemo;
